module.exports = __webpack_public_path__ + "img/default-profile-avatar.e4bea51b.png";